import { Basename } from '@/types/Basename';
import { isEnGbPath } from '@/utils/urls';

export const getBasename = (): Basename => {
    let basename = Basename.ENUS;
    if (typeof window !== 'undefined' && isEnGbPath(window.location.pathname)) {
        basename = Basename.ENGB;
    }
    return basename;
};
